import type { LangCode } from "@/api/types";

import { langTagLabel } from "../../labels";

/** Поле формы review-item: подпись + тэг языка + input.
 *  Read-only по умолчанию; в editable-режиме рендерит input.
 *  keepEmpty — показать «не задан» вместо скрытия (для target_text).
 *  helpTooltip — иконка ⓘ с native browser-tooltip'ом. */
export function Field({
  fieldKey,
  label,
  langTag,
  value,
  mono = false,
  editable = false,
  keepEmpty = false,
  helpTooltip,
  onChange,
}: {
  fieldKey?: string;
  label: string;
  langTag?: LangCode | null;
  value: unknown;
  mono?: boolean;
  editable?: boolean;
  keepEmpty?: boolean;
  helpTooltip?: string;
  onChange?: (key: string, value: string) => void;
}) {
  if (!editable && (value == null || value === "") && !keepEmpty) return null;
  const str =
    value == null
      ? ""
      : typeof value === "string" || typeof value === "number"
        ? String(value)
        : JSON.stringify(value);
  return (
    <div className="mt-field">
      <span className="mt-field__label">
        {langTag && langTag !== "und" && (
          <span className="mt-review__lang-tag">{langTagLabel(langTag)}</span>
        )}
        {label}
        {helpTooltip && (
          <span
            className="mt-help-icon"
            title={helpTooltip}
            aria-label={helpTooltip}
            tabIndex={0}
            style={{
              marginLeft: 6,
              cursor: "help",
              color: "var(--text-soft)",
              fontWeight: 400,
            }}
          >
            ⓘ
          </span>
        )}
      </span>
      {!editable && str === "" && keepEmpty ? (
        <span
          className="mt-muted"
          style={{ fontStyle: "italic", padding: "6px 0" }}
        >
          не задан — нажми «Изменить и принять» или «Suggest»
        </span>
      ) : (
        <input
          className={"mt-input" + (mono ? " mt-input--mono" : "")}
          value={str}
          readOnly={!editable}
          onChange={
            editable && fieldKey && onChange
              ? (e) => onChange(fieldKey, e.target.value)
              : undefined
          }
        />
      )}
    </div>
  );
}
